import type * as React from 'react'

import { type IBaseButtonProps } from './BaseButton'
import { PrimaryButtonStyled } from './styles/PrimaryButtonStyled'

export const PrimaryButton: React.FC<IBaseButtonProps> = PrimaryButtonStyled

PrimaryButton.displayName = 'PrimaryButton'
